// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-title[data-v-20f6d89d] {\n  font-size: 32px;\n  padding: 0;\n  font-weight: 600;\n  line-height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
